/* eslint-disable monsterverse-rules/no-uuid-literals */
export const VoxelAssets = {
  Palette: "1428b9d7-9ddd-4ca7-8315-01c8e507b97d",
};
